import { Injectable } from '@angular/core';
import { PermissionService } from '@app/services/permission/permission.service';
import { ProjectService } from '@app/services/project/project.service';
import { WorkflowRestService } from '@app/services/rest/workflow-rest.service';
import { ReportConfig } from '@interfaces/reports';
import { combineLatest, Observable, of } from 'rxjs';
import { catchError, shareReplay, switchMap } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class ReportService {
	readonly reportConfigs$: Observable<ReportConfig[]>;

	constructor(
		private workflowRestService: WorkflowRestService,
		private projectService: ProjectService,
		permissionService: PermissionService,
	) {
		this.reportConfigs$ = combineLatest([projectService.activeProject$, permissionService.hasPermission$('reports:read')]).pipe(
			switchMap(([project, hasPermission]) => {
				if (project && hasPermission) {
					return this.workflowRestService.getReportConfigs$(project.project_id).pipe(
						catchError(() => of([])),
					);
				} else {
					return of([]);
				}
			}),
			shareReplay({bufferSize: 1, refCount: false }),
		);
	}
}
